(function () {
  'use strict';
  /* =========================================================
     BAESOLE SIZE ENGINE — v5.2
     Width and length are evaluated independently.
     When they disagree substantially the customer gets TWO options
     instead of one forced answer:
        smaller = cleaner / slightly shorter
        larger  = relaxed / more length
     Guards: 2 cm tolerance on length, length may raise at most one step.
     Calibration 180/82 -> L both fits. 188/72 -> M (single).
     v5: table per producttype (tee per gekozen Fit, longsleeve, hoodie,
     sweater) + mouwlengte. Engine zelf ongewijzigd.
     v5.1: sweater = altijd de langere maat (valt kort, 180/82 -> L);
     hoodie dual = M normale fit / L oversized (180/82).
     v5.2: advies herberekent direct bij wissel Cleaner/Relaxed (stond vast);
     "Liever ruimer?" wijst nu naar de volgende maat i.p.v. dezelfde maat.
     ========================================================= */
  window.BaeSize = (function () {
    var ORDER = ['XS', 'S', 'M', 'L', 'XL', 'XXL'];
    function halfChest(h, w) { return 24.5 + (w - 70) * 0.235 + (h - 178) * 0.055; }
    function ease(pref, isBox) { var e = pref === 'clean' ? 32.0 : 36.0; if (isBox) e -= 0.5; return e; }
    function prefLen(h, isBox) { return isBox ? 58 + (h - 160) * 0.36 : 66 + (h - 160) * 0.42; }

    function recommend(h, w, pref, m, isBox) {
      var sizes = ORDER.filter(function (s) { return m[s]; });
      var want = halfChest(h, w) + ease(pref, isBox);
      var need = prefLen(h, isBox);

      var wi = sizes.length - 1;
      for (var i = 0; i < sizes.length; i++) {
        if (m[sizes[i]].w >= want - 0.75) { wi = i; break; }
      }
      var li = wi;
      if (m[sizes[wi]].l < need - 2.0 && wi < sizes.length - 1) li = wi + 1;

      var widthSize = sizes[wi];
      var lengthSize = sizes[li];
      var dual = widthSize !== lengthSize;

      var alt = null;
      if (!dual && wi > 0 && m[sizes[wi - 1]].w >= want - 4.5) alt = sizes[wi - 1];

      return {
        dual: dual,
        size: dual ? lengthSize : widthSize,
        smaller: widthSize,
        larger: lengthSize,
        alt: alt,
        shortBy: (need - m[widthSize].l).toFixed(1),
        widerBy: (m[lengthSize].w - want).toFixed(1)
      };
    }
    return { recommend: recommend, ORDER: ORDER };
  })();

  var modal = document.querySelector('[data-bae-sizemodal]');
  var dataEl = document.querySelector('[data-bae-sizedata]');
  if (!modal || !dataEl) return;

  var data = JSON.parse(dataEl.textContent);
  var isBox = !!data.isBox;
  var pdp = document.querySelector('[data-bae-pdp]');

  /* =========================================================
     LABEL NORMALISATION (XXL <-> 2XL).
     ========================================================= */
  var ALIAS = { '2XL': 'XXL', 'XXL': 'XXL', '3XL': 'XXXL' };
  function norm(label) {
    var u = String(label || '').toUpperCase().trim();
    return ALIAS[u] || u;
  }
  var pdpLabel = {};
  if (pdp) {
    Array.prototype.slice.call(pdp.querySelectorAll('.bae-pdp__sizes [data-bae-optbtn]')).forEach(function (b) {
      pdpLabel[norm(b.dataset.value)] = b.dataset.value;
    });
  }
  function display(canonical) { return pdpLabel[norm(canonical)] || canonical; }

  /* ---------------------------------------------------------
     Gekozen Fit (Oversized/Box) van de PDP lezen. Alleen T-shirts
     met een Fit-optie en zonder eigen garment_measurements wisselen.
     --------------------------------------------------------- */
  function currentFit() {
    if (!pdp) return null;
    var wraps = Array.prototype.slice.call(pdp.querySelectorAll('[data-bae-option-index]'));
    for (var i = 0; i < wraps.length; i++) {
      var k = wraps[i].querySelector('.bae-kicker');
      if (k && /^\s*(fit|pasvorm)\s*$/i.test(k.textContent)) {
        var a = wraps[i].querySelector('[data-bae-optbtn].is-active');
        if (a) {
          var v = String(a.dataset.value || '').toLowerCase();
          if (v.indexOf('box') > -1) return 'box';
          if (v.indexOf('oversized') > -1) return 'oversized';
        }
      }
    }
    return null;
  }

  var M = {};
  var order = [];
  var KIND_LABEL = { tee: 'T-shirt', longsleeve: 'Longsleeve', hoodie: 'Hoodie', sweater: 'Sweater' };

  var tbody = modal.querySelector('[data-bae-sizetable-body]');
  var table = tbody ? tbody.closest('table') : null;
  var capEl = null;
  if (table) {
    capEl = document.createElement('p');
    capEl.className = 'bae-size__intro';
    capEl.setAttribute('data-bae-sizecap', '');
    table.parentNode.insertBefore(capEl, table);
  }

  function load() {
    var src = data.m || {};
    var box = !!data.isBox;
    var fitName = null;
    if (data.kind === 'tee' && !data.custom && data.fits) {
      var f = currentFit();
      if (f && data.fits[f]) { src = data.fits[f]; box = (f === 'box'); fitName = f; }
      else { fitName = box ? 'box' : 'oversized'; }
    }
    isBox = box;
    M = {};
    Object.keys(src).forEach(function (k) { M[norm(k)] = src[k]; });
    order = window.BaeSize.ORDER.filter(function (s) { return M[s]; });

    var hasSleeve = order.some(function (s) { return typeof M[s].s === 'number'; });
    if (tbody) {
      tbody.innerHTML = order.map(function (s) {
        return '<tr><td>' + display(s) + '</td><td>' + M[s].w + ' cm</td><td>' + M[s].l + ' cm</td>' +
          (hasSleeve ? '<td>' + (typeof M[s].s === 'number' ? M[s].s + ' cm' : '—') + '</td>' : '') + '</tr>';
      }).join('');
      var headRow = table.querySelector('thead tr');
      if (headRow) {
        var extra = headRow.querySelector('[data-bae-sleevehead]');
        if (hasSleeve && !extra) {
          var th = document.createElement('th');
          th.setAttribute('data-bae-sleevehead', '');
          th.textContent = 'Mouw';
          headRow.appendChild(th);
        } else if (!hasSleeve && extra) {
          extra.parentNode.removeChild(extra);
        }
      }
    }
    if (capEl) {
      var label = KIND_LABEL[data.kind] || 'Item';
      if (fitName === 'box') label += ' · Box fit';
      else if (fitName === 'oversized') label += ' · Oversized fit';
      else if (data.kind === 'longsleeve') label += ' · Oversized boxy';
      else if (data.kind === 'hoodie' || data.kind === 'sweater') label += ' · Oversized';
      capEl.textContent = 'Maattabel: ' + label + '. Breedte = plat gemeten over de borst, lengte van schouder tot onderkant' + (hasSleeve ? ', mouw vanaf de schouder.' : '.');
    }
  }
  load();

  /* Fit gewijzigd op de PDP -> tabel en advies meewisselen. */
  if (pdp) {
    pdp.addEventListener('click', function (e) {
      if (e.target && e.target.closest && e.target.closest('[data-bae-optbtn]')) {
        setTimeout(load, 0);
      }
    });
  }

  function open(tab) {
    load();
    modal.hidden = false;
    requestAnimationFrame(function () { modal.classList.add('is-open'); });
    document.body.style.overflow = 'hidden';
    showTab(tab || 'assistant');
    try {
      document.dispatchEvent(new CustomEvent('bae:size:open', { detail: { tab: tab || 'assistant', fit: isBox ? 'box' : 'oversized', kind: data.kind } }));
    } catch (err) {}
  }
  function close() {
    modal.classList.remove('is-open');
    document.body.style.overflow = '';
    setTimeout(function () { modal.hidden = true; }, 280);
  }
  function showTab(n) {
    modal.querySelectorAll('[data-bae-sizetab]').forEach(function (b) { b.classList.toggle('is-active', b.dataset.baeSizetab === n); });
    modal.querySelectorAll('[data-bae-sizepane]').forEach(function (p) { p.hidden = p.dataset.baeSizepane !== n; });
    if (window.BaeToggle) window.BaeToggle.sync();
  }

  document.querySelectorAll('[data-bae-size-open]').forEach(function (b) {
    b.addEventListener('click', function () { open(b.dataset.baeSizeOpen); });
  });
  modal.querySelectorAll('[data-bae-size-close]').forEach(function (b) { b.addEventListener('click', close); });
  modal.querySelectorAll('[data-bae-sizetab]').forEach(function (b) {
    b.addEventListener('click', function () { showTab(b.dataset.baeSizetab); });
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && modal.classList.contains('is-open')) close();
  });

  var pref = 'relaxed';
  modal.querySelectorAll('[data-bae-pref]').forEach(function (b) {
    b.addEventListener('click', function () {
      modal.querySelectorAll('[data-bae-pref]').forEach(function (x) { x.classList.remove('is-active'); });
      b.classList.add('is-active');
      pref = b.dataset.baePref;
      if (window.BaeToggle) window.BaeToggle.sync();
      /* v5.2: staat er al een advies, dan direct opnieuw berekenen. */
      var resEl = modal.querySelector('[data-bae-size-result]');
      var goBtn = modal.querySelector('[data-bae-size-go]');
      if (resEl && !resEl.hidden && goBtn) goBtn.click();
    });
  });

  function selectOnPdp(size) {
    if (!pdp) return;
    var btn = Array.prototype.slice.call(pdp.querySelectorAll('.bae-pdp__sizes [data-bae-optbtn]'))
      .filter(function (b) { return norm(b.dataset.value) === norm(size); })[0];
    if (btn && !btn.disabled) btn.click();
  }

  var go = modal.querySelector('[data-bae-size-go]');
  if (!go) return;
  go.addEventListener('click', function () {
    load();
    var h = Number(modal.querySelector('[data-bae-height]').value);
    var w = Number(modal.querySelector('[data-bae-weight]').value);
    var res = modal.querySelector('[data-bae-size-result]');
    var ans = modal.querySelector('[data-bae-size-answer]');
    var plain = modal.querySelector('[data-bae-size-plain]');
    var altEl = modal.querySelector('[data-bae-size-alt]');

    if (!h || !w || h < 140 || w < 40) {
      res.hidden = false;
      ans.textContent = '—';
      plain.textContent = 'Vul je lengte en gewicht in.';
      altEl.innerHTML = '';
      return;
    }

    var r = window.BaeSize.recommend(h, w, pref, M, isBox);
    var sweaterShort = false;
    if (data.kind === 'sweater' && r.dual) {
      /* Crewneck valt kort: de kortere maat is geen goede optie. */
      r.dual = false;
      r.size = r.larger;
      r.alt = null;
      sweaterShort = true;
    }
    res.hidden = false;

    var optA = data.kind === 'hoodie' ? 'normale fit' : 'cleaner, iets korter';
    var optB = data.kind === 'hoodie' ? 'extra oversized, meer lengte' : 'relaxed, meer lengte';

    if (r.dual) {
      ans.innerHTML = '<span class="bae-size__dual">' +
        '<button type="button" class="bae-size__opt" data-pick="' + r.smaller + '">' +
          '<strong>' + display(r.smaller) + '</strong><span>' + optA + '</span></button>' +
        '<button type="button" class="bae-size__opt is-rec" data-pick="' + r.larger + '">' +
          '<strong>' + display(r.larger) + '</strong><span>' + optB + '</span></button>' +
        '</span>';
      plain.textContent = 'Bij jouw lengte valt ' + display(r.smaller) + ' ongeveer ' + r.shortBy +
        ' cm korter dan de bedoelde vorm, terwijl ' + display(r.larger) + ' ongeveer ' + r.widerBy +
        ' cm ruimer zit. Allebei kloppen — het hangt af van wat je wilt.';
      altEl.innerHTML = '';
      ans.querySelectorAll('[data-pick]').forEach(function (b) {
        b.addEventListener('click', function () {
          ans.querySelectorAll('[data-pick]').forEach(function (x) { x.classList.remove('is-rec'); });
          b.classList.add('is-rec');
          selectOnPdp(b.dataset.pick);
        });
      });
      selectOnPdp(r.larger);
    } else {
      ans.textContent = 'Maat ' + display(r.size);
      plain.textContent = sweaterShort
        ? 'Deze crewneck valt kort. ' + display(r.size) + ' geeft de juiste lengte.'
        : (isBox
          ? 'Deze fit valt korter en boxy. ' + display(r.size) + ' geeft de bedoelde vorm.'
          : (pref === 'clean' ? 'Voor een cleanere, minder ruime BAESOLÉ fit.' : 'Voor de bedoelde relaxed BAESOLÉ fit.'));
      var nextUp = order[order.indexOf(r.size) + 1];
      altEl.textContent = pref === 'clean'
        ? ((nextUp && !sweaterShort) ? 'Liever ruimer? Kies ' + display(nextUp) + '.' : '')
        : (r.alt ? 'Liever iets cleaner? Kies ' + display(r.alt) + '.' : '');
      selectOnPdp(r.size);
    }

    var focus = r.dual ? r.larger : r.size;
    var i = order.indexOf(focus);
    var near = [order[i - 1], order[i], order[i + 1]].filter(Boolean);
    modal.querySelector('[data-bae-size-compare]').innerHTML = near.map(function (s) {
      var on = r.dual ? (s === r.smaller || s === r.larger) : (s === r.size);
      return '<span class="bae-size__chip' + (on ? ' is-rec' : '') + '">' + display(s) + ' · ' + M[s].w + ' × ' + M[s].l + ' cm</span>';
    }).join('');

    try {
      document.dispatchEvent(new CustomEvent('bae:size:result', {
        detail: {
          fit: isBox ? 'box' : 'oversized',
          kind: data.kind,
          dual: r.dual,
          size: display(r.dual ? r.larger : r.size),
          smaller: display(r.smaller),
          larger: display(r.larger),
          height: h,
          weight: w,
          pref: pref
        }
      }));
    } catch (err) {}
  });
})();
